package pl.decks.personal.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.browser.dom.observers.ResizeObserver

@Composable
fun rememberElementSize(elementId: String): MutableState<Pair<Double, Double>> {
    val size = remember { mutableStateOf(Pair(0.0, 0.0)) }
    DisposableEffect(elementId) {
        val element = kotlinx.browser.document.getElementById(elementId)
            ?: return@DisposableEffect onDispose {}
        val observer = ResizeObserver { entries, _ ->
            val entry = entries.firstOrNull() ?: return@ResizeObserver
            size.value = Pair(entry.contentRect.width, entry.contentRect.height)
        }
        observer.observe(element)
        onDispose { observer.disconnect() }
    }
    return size
}
